// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__g7EwB","MapBlock":"Footer_MapBlock__qUcjs","MapLink":"Footer_MapLink__gro3n"};